import { useEffect, useState } from 'react';
import Menu from './Compartido/Menu.jsx';
import Popup from './Compartido/Popup.jsx';
import Banner from './Inicio/Banner.jsx';
import Ventajas from './Inicio/Ventajas.jsx';
import Presentacion from './Inicio/Presentacion.jsx';
import Servicios from './Inicio/Servicios.jsx';
import Ofertas from './Inicio/Ofertas.jsx';
import Entorno from './Inicio/Entorno.jsx';
import Restaurante from './Inicio/Restaurante.jsx';
import Comentarios from './Inicio/Comentarios.jsx';
import NoticiasHome from './Inicio/NoticiasHome.jsx';
import Mapa from './Inicio/Mapa.jsx';
import TextoPiePgina from './Inicio/TextoPiePagina.jsx';
import Footer from './Compartido/Footer.jsx';
import textosCamprodon, { RUTA_IMATGES } from './Compartido/contenidoCamprodon.js';
import '../../../../css/web/hotelcamprodon/inicio.css';

// Portada amb l'estructura i els textos de www.hotelcamprodon.com
// (contenidoCamprodon.js). El cercador, les valoracions, el blog i el mapa
// segueixen sortint de BedLoop.
const Inicio = (props) => {

    const textos = textosCamprodon(props.lang);

    const [mostraTornar, setMostraTornar] = useState(false);

    useEffect(() => {
        const alFerScroll = () => setMostraTornar(window.scrollY > window.innerHeight);
        window.addEventListener('scroll', alFerScroll, { passive: true });
        return () => window.removeEventListener('scroll', alFerScroll);
    }, []);

    return (
        <main className="bhh hc">
            <Menu
                destinos={props.destinos}
                sobrenosotros={props.textosobrenosotros}
                clientes={props.textoclientes}
                propietarios={props.textopropietarios}
                servicios={props.textoservicios}
                experiencias={props.experiencias}
                idiomas={props.idiomas}
                lang={props.lang}
                tiposcasas={props.tiposcasas}
                config={props.websgrupo}
                textopropiedades={props.textopropiedades}
                edificios={props.edificios}
                marcas={props.marcas}
                ruta={props.ruta}
                destinoslarga={props.destinoslarga}
                meta_titulo={props.meta_titulo}
                meta_descripcion={props.meta_descripcion}
                meta_keywords={props.meta_keywords}
                numblog={props.numblog}
                numfaqs={props.numfaqs}
                paginapersonalizada={props.paginapersonalizada}
                transparente={true}
            />

            <Popup
                popup={props.popup}
                lang={props.lang}
            />

            <Banner
                destinos={props.destinos}
                lang={props.lang}
                ruta={props.ruta}
                d_ale={props.aleatori}
                config={props.websgrupo}
                capacidad_maxima={props.capacidad_maxima}
                noninos={props.noninos}
                nobebes={props.nobebes}
                elementosweb={props.elementosweb}
            />
            <Ventajas />
            <Presentacion
                textos={textos}
                lang={props.lang}
                sobrenosotros={props.textosobrenosotros}
                elementosweb={props.elementosweb}
                ruta={props.ruta}
            />
            <Servicios textos={textos} servicios={props.textoservicios} />
            <Ofertas textos={textos} lang={props.lang} />
            <Entorno textos={textos} lang={props.lang} />
            <Restaurante textos={textos} lang={props.lang} />
            <Comentarios
                comentarios={props.comentaris}
                lang={props.lang}
                config={props.websgrupo}
                ruta={props.ruta}
            />
            <NoticiasHome
                noticias={props.noticias}
                ruta={props.ruta}
                lang={props.lang}
                elementosweb={props.elementosweb}
            />
            <Mapa
                destinos={props.destinos}
                elementosweb={props.elementosweb}
                config={props.websgrupo}
                lang={props.lang}
            />
            <TextoPiePgina
                elementosweb={props.elementosweb}
                lang={props.lang}
                config={props.websgrupo}
            />
            <Footer
                datos={props.websgrupo}
                terminos={props.textoterminos}
                protocolos={props.textoprotocolos}
                avisolegal={props.textoavisolegal}
                politicaprivacidad={props.textopolitica}
                lang={props.lang}
                ruta={props.ruta}
                logos_pie={props.logos_pie}
                websgrupo={props.websgrupo}
                numfaqs={props.numfaqs}
            />
            <div className="bhh-fixed-search-spacer"></div>

            <button
                type="button"
                className={"c-back-to-top" + (mostraTornar ? " is-visible" : "")}
                aria-label="Back to top"
                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            >
                <svg aria-hidden="true" focusable="false" className="c-icon" width="48" height="48">
                    <use href={RUTA_IMATGES + "icons-sprite.svg#sprite-icon-ico-back-to-top"}></use>
                </svg>
            </button>
        </main>
    );
}

export default Inicio;
